import { suggestAlxPassMapping } from '../alx/alxPassMapper'
import { suggestPrefixMapping } from '../weldPassPrefixMapper'
import { suggestNumberedPassMapping } from '../weldPassNumberedMapper'
import { passRawFromMappingKey } from './passMappingKeys'

export type PassMappingHeuristicMode = 'telemetry' | 'alx'

export function buildPassMappings(input: {
  passNames: string[]
  wpsPassLabels: string[]
  globalSuggestions?: Record<string, string>
  heuristicMode?: PassMappingHeuristicMode
}): Record<string, string> {
  const passLabelSet = new Set(input.wpsPassLabels)
  const mappings: Record<string, string> = {}
  const heuristicMode = input.heuristicMode ?? 'telemetry'

  for (const key of input.passNames) {
    const passRaw = passRawFromMappingKey(key)
    const global = input.globalSuggestions?.[key] ?? input.globalSuggestions?.[passRaw]
    if (global && passLabelSet.has(global)) {
      mappings[key] = global
      continue
    }
    if (passLabelSet.has(passRaw)) {
      mappings[key] = passRaw
      continue
    }
    const suggested =
      heuristicMode === 'alx'
        ? suggestAlxPassMapping(passRaw, input.wpsPassLabels)
        : suggestNumberedPassMapping(passRaw, input.wpsPassLabels) ??
          suggestPrefixMapping(passRaw, input.wpsPassLabels)
    mappings[key] = suggested ?? ''
  }

  return mappings
}
